import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

export const Clothes: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <>
      <Title className={Typography.BODY_14_MEDIUM} color={vars.v3Color.gray500}>
        - 아우터 / 상의 / 원피스
      </Title>
      <Table>
        <Head className={Typography.CAPTION_12_SEMIBOLD}>
          <ColHead>사이즈</ColHead>
          <ColHead>한국</ColHead>
          <ColHead>일본</ColHead>
          <ColHead>미국</ColHead>
        </Head>
        <Row className={Typography.CAPTION_11_REGULAR}>
          <ColHead className={Typography.CAPTION_12_SEMIBOLD}>XS</ColHead>
          <Col>44(85)</Col>
          <Col>44</Col>
          <Col>2</Col>
        </Row>
        <Row className={Typography.CAPTION_11_REGULAR}>
          <ColHead className={Typography.CAPTION_12_SEMIBOLD}>S</ColHead>
          <Col>55(90)</Col>
          <Col>55</Col>
          <Col>4</Col>
        </Row>
        <Row className={Typography.CAPTION_11_REGULAR}>
          <ColHead className={Typography.CAPTION_12_SEMIBOLD}>M</ColHead>
          <Col>66(95)</Col>
          <Col>66</Col>
          <Col>6</Col>
        </Row>
        <Row className={Typography.CAPTION_11_REGULAR}>
          <ColHead className={Typography.CAPTION_12_SEMIBOLD}>L</ColHead>
          <Col>77(100)</Col>
          <Col>77</Col>
          <Col>8</Col>
        </Row>
        <Row className={Typography.CAPTION_11_REGULAR}>
          <ColHead className={Typography.CAPTION_12_SEMIBOLD}>XL</ColHead>
          <Col>88(105)</Col>
          <Col>88L</Col>
          <Col>10</Col>
        </Row>
      </Table>
      <Title className={Typography.BODY_14_MEDIUM} color={vars.v3Color.gray500}>
        - 하의
      </Title>
      <Table>
        <Head className={Typography.CAPTION_12_SEMIBOLD}>
          <Col>사이즈</Col>
          <Col>
            한국
            <Unit>(inch)</Unit>
          </Col>
          <Col>일본</Col>
          <Col>미국</Col>
        </Head>
        <Row className={Typography.CAPTION_11_REGULAR}>
          <ColHead className={Typography.CAPTION_12_SEMIBOLD}>XS</ColHead>
          <Col>24-25</Col>
          <Col>7</Col>
          <Col>2-4</Col>
        </Row>
        <Row className={Typography.CAPTION_11_REGULAR}>
          <ColHead className={Typography.CAPTION_12_SEMIBOLD}>S</ColHead>
          <Col>26-27</Col>
          <Col>9</Col>
          <Col>4-6</Col>
        </Row>
        <Row className={Typography.CAPTION_11_REGULAR}>
          <ColHead className={Typography.CAPTION_12_SEMIBOLD}>M</ColHead>
          <Col>28-29</Col>
          <Col>11</Col>
          <Col>6-8</Col>
        </Row>
        <Row className={Typography.CAPTION_11_REGULAR}>
          <ColHead className={Typography.CAPTION_12_SEMIBOLD}>L</ColHead>
          <Col>30-31</Col>
          <Col>13</Col>
          <Col>8-10</Col>
        </Row>
      </Table>
      <Title className={Typography.BODY_15_SEMIBOLD} color={vars.v3Color.gray900} margin_bottom={16}>
        실측 참고
      </Title>
      <Table>
        <Head className={Typography.CAPTION_12_SEMIBOLD}>
          <ColHead>가슴</ColHead>
          <ColHead>허리</ColHead>
          <ColHead>엉덩이</ColHead>
        </Head>
        <SubHead className={Typography.CAPTION_12_MEDIUM}>
          <ColGroup>
            <ColHead>cm</ColHead>
            <ColHead>inch</ColHead>
          </ColGroup>
          <ColGroup>
            <ColHead>cm</ColHead>
            <ColHead>inch</ColHead>
          </ColGroup>
          <ColGroup>
            <ColHead>cm</ColHead>
            <ColHead>inch</ColHead>
          </ColGroup>
        </SubHead>
        <Row className={Typography.CAPTION_11_REGULAR}>
          <Col>41-46</Col>
          <Col>16-18</Col>
          <Col>28-33</Col>
          <Col>11-13</Col>
          <Col>36-41</Col>
          <Col>14-16</Col>
        </Row>
        <Row className={Typography.CAPTION_11_REGULAR}>
          <Col>48-53</Col>
          <Col>19-21</Col>
          <Col>36-41</Col>
          <Col>14-16</Col>
          <Col>43-48</Col>
          <Col>17-19</Col>
        </Row>
        <Row className={Typography.CAPTION_11_REGULAR}>
          <Col>56-61</Col>
          <Col>22-24</Col>
          <Col>43-48</Col>
          <Col>17-19</Col>
          <Col>51-56</Col>
          <Col>20-22</Col>
        </Row>
        <Row className={Typography.CAPTION_11_REGULAR}>
          <Col>64-69</Col>
          <Col>25-27</Col>
          <Col>51-56</Col>
          <Col>20-22</Col>
          <Col>58-64</Col>
          <Col>23-25</Col>
        </Row>
      </Table>
      <Notice className={Typography.BODY_13_REGULAR}>*위의 치수는 '단면의 길이'입니다. 참고해 주세요.</Notice>
    </>
  );
};

const Title = styled.h4<{ color?: string; margin_bottom?: number }>`
  margin-bottom: ${({ margin_bottom = 12 }) => margin_bottom}px;
  ${({ color }) => color && `color: ${color}`}
`;

const Table = styled.div`
  width: 100%;
  margin-bottom: 24px;
  text-align: center;
  border-collapse: collapse;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

const Head = styled.div`
  display: flex;
  align-items: center;
  background-color: ${vars.v3Color.gray100};
`;

const SubHead = styled(Head)`
  border-top: 1px solid ${vars.v3Color.staticWhite};
`;

const Col = styled.div`
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 0;
  border-bottom: 1px solid ${vars.v3Color.gray100};
`;

const ColHead = styled(Col)`
  color: ${vars.v3Color.gray900};
`;

const ColGroup = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid ${vars.v3Color.staticWhite};

  &:last-of-type {
    border-right: 0;
  }
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  color: ${vars.v3Color.gray700};

  &:last-of-type {
    ${ColHead},
    ${Col} {
      border-color: ${vars.v3Color.gray150};
    }
  }
`;

const Unit = styled.small`
  font-size: 10px;
  line-height: 12px;
  font-weight: 400;
`;

const Notice = styled.p`
  margin-top: 12px;
  color: ${vars.v3Color.gray400};
`;
